import React, { createContext, useContext } from 'react'
import { IntlProvider as ReactIntlProvider, useIntl as useReactIntl } from 'react-intl'
import { messages } from './locales'
import { getCurrentLocale } from './utils'

// 创建上下文
const LocaleContext = createContext()

/**
 * 国际化Provider组件
 * 用于包裹整个应用，提供国际化支持
 */
export const IntlProvider = ({ children }) => {
  const locale = getCurrentLocale()
  const messagesForLocale = messages[locale] || messages['zh-CN']

  return (
    <LocaleContext.Provider value={{ locale }}>
      <ReactIntlProvider
        locale={locale}
        messages={messagesForLocale}
        defaultLocale="zh-CN"
      >
        {children}
      </ReactIntlProvider>
    </LocaleContext.Provider>
  )
}

/**
 * 获取国际化翻译的Hook
 * 使用方式:
 * const { formatMessage } = useIntl()
 * const text = formatMessage({ id: 'common.confirm' })
 */
export const useIntl = () => {
  return useReactIntl()
}

/**
 * 获取当前语言的Hook
 */
export const useLocale = () => {
  const context = useContext(LocaleContext)
  if (!context) {
    throw new Error('useLocale must be used within IntlProvider')
  }
  return context.locale
}

/**
 * 简化的翻译函数Hook
 * 使用方式:
 * const t = useTranslation()
 * const text = t('common.confirm')
 */
export const useTranslation = () => {
  const { formatMessage } = useIntl()
  
  return (id, values) => {
    return formatMessage({ id }, values)
  }
}

/**
 * FormattedMessage组件的便捷导出
 */
export { FormattedMessage, FormattedNumber, FormattedDate, FormattedTime } from 'react-intl'
